export default state => state.vod.hodor.authenticate.error || null;
